import React from "react"
import { useSelector } from "react-redux"
import _ from "lodash"

import { getProduct } from "@/onboarding/features/product/selectors"
import TextDisplay from "@/onboarding/features/product/components/shared/TextDisplay"

const OperatorDisplay = ({ operatorId, previousValue = false }) => {
  const { seasonOperators: options } = useSelector(getProduct)
  const operator = _.find(options, (o) => o.value === operatorId)?.label

  return <TextDisplay value={operator} previousValue={previousValue} />
}

export default OperatorDisplay
